import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getRequests,
  updateRequest,
  resetCourseState,
  getCourseRequests,
  updateACourseRequest,
} from "../features/courseRequests/courseRequestSlice";
import { BiArrowBack } from "react-icons/bi";

const ViewCourseRequest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const requestId = location.pathname.split("/")[3];
  const courseRequests = useSelector((state) => state.courseRequests.courseRequests);

  const request = courseRequests?.find(req => req._id === requestId);

  useEffect(() => {
    if (!courseRequests.length) {
      dispatch(getCourseRequests());
    }
  }, [dispatch, courseRequests.length]);

  const goBack = () => {
    navigate(-1);
  };

  const setRequestStatus = (e, id) => {
    const data = { id, requestData: e };
    dispatch(updateACourseRequest(data));

    setTimeout(() => {
      dispatch(getCourseRequests()); // Refresh after update
    }, 100);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="mb-4 title">View Course Request</h3>
        <button
          className="bg-transparent back-button border-0 fs-6 mb-0 d-flex align-items-center gap-1"
          onClick={goBack}
        >
          <BiArrowBack className="fs-5 back-icon" /> Go Back
        </button>
      </div>
      <div className="view-booking-wrapper">
        <div className="view-booking-content">
          <div className="bg-white p-4 d-flex gap-3 flex-column rounded-3">
            <h4>Course Details</h4>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th>Course Title</th>
                  <td>{request?.courseTitle}</td>
                </tr>
                <tr>
                  <th>Duration</th>
                  <td>{request?.duration}</td>
                </tr>
                <tr>
                  <th>Price</th>
                  <td>KES {request?.price?.toLocaleString()}</td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>{request?.status}</td>
                </tr>
              </tbody>
            </table>

            <h4>User Details</h4>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>{request?.name}</td>
                </tr>
                <tr>
                  <th>Phone</th>
                  <td><a href={`tel:${request?.phone}`}>{request?.phone}</a></td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td><a href={`mailto:${request?.email}`}>{request?.email}</a></td>
                </tr>
                <tr>
                  <th>Preferred Contact</th>
                  <td>{request?.contactMethod}</td>
                </tr>
              </tbody>
            </table>

            <div className="d-flex mt-5 align-items-center gap-3">
              <h6 className="mb-0">Change Status:</h6>
              <div>
                <select
                  value={request?.status || "Submitted"}
                  className="form-control form-select"
                  onChange={(e) => setRequestStatus(e.target.value, request?._id)}
                >
                  <option value="Submitted">Submitted</option>
                  <option value="Contacted">Contacted</option>
                  <option value="Enrolled">Enrolled</option>
                  <option value="Declined">Declined</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCourseRequest;
